"use client";
import Image, { ImageProps, ImageLoader } from "next/image";
import { SanityImageSource } from "@sanity/image-url/lib/types/types";
import { urlFor } from "@/sanity/lib/utils";

const cloudflareLoader: ImageLoader = ({ src, width, quality }) => {
  if (process.env.NEXT_PUBLIC_CF_IMAGE_ZONE) {
    const zone = process.env.NEXT_PUBLIC_CF_IMAGE_ZONE;
    const params = `format=auto,quality=${quality || 80},width=${width}`;
    return `https://${zone}/cdn-cgi/image/${params}/${src}`;
  }
  
  // When Cloudflare is not configured, use Sanity's image CDN with width
  // Check if the URL already has query parameters
  const separator = src.includes('?') ? '&' : '?';
  return `${src}${separator}w=${width}&q=${quality || 80}&auto=format`;
};

type SanityImageProps = Omit<ImageProps, "src"> & {
  src: SanityImageSource;
};

export function SanityImage({ src, ...props }: SanityImageProps) {
  try {
    const baseUrl = urlFor(src);
    return (
      <Image
        src={baseUrl}
        loader={cloudflareLoader}
        {...props}
        alt={props.alt || ""}
        unoptimized
      />
    );
  } catch (err) {
    console.log(err);
    return null;
  }
}